import { useSellerCoupons } from '@util/hooks/useSellerCoupons';
import type { ProductDocument } from 'models/product';
import { formatCurrency } from '@util/index';

type ProductCouponDisplayProps = {
  product: ProductDocument;
};

export default function ProductCouponDisplay({
  product,
}: ProductCouponDisplayProps) {
  const { sellerCoupons } = useSellerCoupons({
    seller_id: product.seller_id,
    is_private: false,
    is_active: true,
  });

  if (product.is_auction) {
    return null;
  }

  // const {
  //   addCoupons,
  //   removeCoupon,
  //   cart,
  //   setCartOpen,
  //   canAddProductToCart,
  //   increaseCartQty,
  // } = useShoppingCart();
  // const { getAttribution } = useAttributionContext();
  // const { showErrorToast } = useToastContext();
  // const { userDoc } = useAuth();
  // const router = useRouter();
  // const pathname = usePathname();

  if (
    !sellerCoupons?.length ||
    !sellerCoupons.some((coupon) => coupon.active)
  ) {
    return null;
  }

  const activeCoupon = sellerCoupons.find(
    (coupon) => !coupon.product_id && coupon.active && !coupon.buyer_id
  );

  // const handleAddToCart = () => {
  //   if (!userDoc) {
  //     router.push(`/login?redirect=${encodeURI(pathname ?? '')}`);
  //     return;
  //   }

  //   if (!canAddProductToCart(product.id)) {
  //     showErrorToast('Cannot add product to cart');
  //     setCartOpen(true);
  //     return;
  //   }

  //   const attribution = getAttribution(product.id);
  //   const cartItem = getCartItemFromProductDocument(product, [], attribution);
  //   increaseCartQty(cartItem);
  // };

  // const isCouponApplied =
  //   cart?.coupons?.some((coupon) => coupon.code === activeCoupon?.code) ??
  //   false;

  // const handleCouponToggle = (selected?: boolean) => {
  //   if (!activeCoupon) {
  //     return;
  //   }

  //   if (selected) {
  //     addCoupons([activeCoupon]);
  //     handleAddToCart();
  //   } else {
  //     removeCoupon(activeCoupon);
  //   }
  // };

  if (!activeCoupon) return null;

  return (
    <div className="flex items-center gap-4">
      <p className="text-[1.6rem] font-semibold text-brand-secondary">
        Take an extra{' '}
        {activeCoupon.amount_off
          ? `${formatCurrency(activeCoupon.amount_off)} OFF`
          : activeCoupon.percent_off
          ? `${activeCoupon.percent_off}% OFF`
          : ''}{' '}
        with code {activeCoupon.code} at checkout
      </p>
    </div>
  );
}
